import React, { useState, useRef } from 'react';
import mqtt from 'mqtt';

export default function BrainstormDebug() {
    const [sessionId, setSessionId] = useState(null);
    const [agents, setAgents] = useState({});
    const [moderator, setModerator] = useState(null);
    const [messages, setMessages] = useState([]);
    const clientRef = useRef(null);

    const startSession = async () => {
        try {
            const response = await fetch('/brainstorm/start-session', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                }
            });
            
            const data = await response.json();
            setSessionId(data.session_id);
            
            // Connect to MQTT after session starts
            const client = mqtt.connect('ws://localhost:9001');
            clientRef.current = client;
            
            client.on('connect', () => {
                client.subscribe(`agents-brainstorm/sessions/${data.session_id}/#`);
            });
            
            client.on('message', (topic, message) => {
                const data = JSON.parse(message.toString());
                
                setMessages(prev => [...prev, { topic, data, time: new Date().toLocaleTimeString() }]);
                
                if (data.type === 'agent_response') {
                    setAgents(prev => ({
                        ...prev,
                        [data.agent_id]: data
                    }));
                } else if (data.type === 'moderator_synthesis') {
                    setModerator(data);
                }
            });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const runIteration = () => {
        if (!clientRef.current || !sessionId) return;
        
        clientRef.current.publish(
            `agents-brainstorm/sessions/${sessionId}/iteration`,
            JSON.stringify({
                action: 'run_iteration',
                user_input: {
                    scene_content: "INT. COFFEE SHOP - DAY\n\nSARAH sits alone.",
                    additional_guidance: "Make it more tense"
                }
            })
        );
        
        setAgents({});
        setModerator(null);
    };

    return (
        <div className="container mt-4">
            <h1>Brainstorm Debug</h1>
            
            <div className="mb-3">
                {!sessionId ? (
                    <button className="btn btn-primary" onClick={startSession}>
                        Start Session
                    </button>
                ) : (
                    <>
                        <button className="btn btn-success" onClick={runIteration}>
                            Run Iteration
                        </button>
                        <span className="ms-3 text-muted">Session: {sessionId}</span>
                    </>
                )}
            </div>

            <div className="row">
                {Object.entries(agents).map(([id, agent]) => (
                    <div key={id} className="col-md-6 mb-3">
                        <div className="card">
                            <div className="card-header">
                                <strong>{agent.agent_name}</strong>
                            </div>
                            <div className="card-body">
                                <p>{agent.response}</p>
                                <small className="text-muted">{agent.timestamp}</small>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {moderator && (
                <div className="alert alert-success mt-3">
                    <h5>Moderator Synthesis</h5>
                    <pre>{JSON.stringify(moderator.synthesis, null, 2)}</pre>
                </div>
            )}

            <div className="mt-4">
                <h5>Debug Log</h5>
                <div className="border p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {messages.slice(-5).reverse().map((msg, idx) => (
                        <div key={idx} className="small">
                            <strong>{msg.time}</strong> - {msg.topic}
                            <pre className="mb-1">{JSON.stringify(msg.data, null, 2)}</pre>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}